import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import queryString from 'query-string';
import P from '@deliveroo/consumer-component-library/components/P';
import Button from '@deliveroo/consumer-component-library/components/Button';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import i18n from '../../utils/i18n';

import { Container } from '../../atoms';
import riderImage from './images/riders.jpg';
import restaurantImage from './images/restaurants.jpg';
import teamImage from './images/team.jpg';

import styles from './styles.scss';

export default function HomepageWorkWithUs({ country, careersLink }) {
  const createLinkButton = (href, label, isExternal = false) => (
    <Button href={href} newWindow={isExternal}>
      {label}
    </Button>
  );

  const restaurantUrl = country.restaurantsHomepageUrl || '/restaurant-signup';
  const rideWithUsParams = {
    'utm-campaign': 'ridewithus_lower',
    'utm-medium': 'organic',
    'utm-source': 'landingpage',
  };

  const cards = [
    {
      className: 'ride',
      title: i18n.gettext('homepage.riders.title'),
      description: i18n.gettext('homepage.riders.body'),
      image: riderImage,
      button: createLinkButton(
        `/apply?${queryString.stringify(rideWithUsParams)}`,
        i18n.gettext('homepage.riders.button'),
      ),
    },
    {
      className: 'deliver',
      title: i18n.gettext('homepage.restaurants.title'),
      description: i18n.gettext('homepage.restaurants.body'),
      image: restaurantImage,
      button: createLinkButton(restaurantUrl, i18n.gettext('homepage.restaurants.button'), true),
    },
    {
      className: 'work',
      title: i18n.gettext('homepage.careers.title'),
      description: i18n.gettext('homepage.careers.body'),
      image: teamImage,
      button: createLinkButton(careersLink, i18n.gettext('homepage.careers.button')),
    },
  ];

  return (
    <section className={styles.wrapper}>
      <Container>
        <h3 className={styles.title}>{i18n.gettext('homepage.workwithus.sectiontitle')}</h3>
        <div className={styles.cards}>
          {cards.map((card) => (
            <div key={card.className} className={classnames(styles.card, styles[card.className])}>
              <div className={styles['card-image-container']}>
                <BackgroundImage src={card.image}>
                  <svg
                    className={styles['card-slant']}
                    viewBox="0 0 235 25"
                    preserveAspectRatio="xMinYMax slice"
                  >
                    <polygon points="235 0 235 25 0 25" />
                  </svg>
                </BackgroundImage>
              </div>
              <div className={styles['card-info']}>
                <h4 className={styles['card-title']}>{card.title}</h4>
                <P color="white">{card.description}</P>
                <span className={styles['card-button']}>{card.button}</span>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

HomepageWorkWithUs.propTypes = {
  country: PropTypes.shape({
    restaurantsHomepageUrl: PropTypes.string.isRequired,
  }).isRequired,
  careersLink: PropTypes.string.isRequired,
};
